// extracted by mini-css-extract-plugin
export var paginationContainer = "_al-0";